import { Suspense, lazy } from 'react';
import { t } from '@/utils/i18n';
import { DesignUploadModalProps } from '@/redux/modal/types';
import { LoadingOverlay } from '@/components/common/LoadingOverlay';
import { ModalProps } from '@/components/common/ModalManager';
import { Modal, ModalHeader, ModalTitle } from '@/components/common/modal/modal';

const LazyDesignUploadDialog = lazy(
  () => import(/* webpackChunkName: 'design-upload-dialog' */ './DesignUploadDialog')
);

export const AsyncDesignUploadDialog = ({
  configurations,
  dismiss,
  onCancel,
}: DesignUploadModalProps & ModalProps) => {
  const title = t('uploadDialog.title');

  return (
    <Modal title={title} className="design-upload-dialog" onClose={onCancel}>
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <Suspense fallback={<LoadingOverlay />}>
        <LazyDesignUploadDialog configurations={configurations} dismiss={dismiss} />
      </Suspense>
    </Modal>
  );
};
